module.exports = __webpack_public_path__ + "img/IO-Controls_Logo.a2e8807e.png";